app.service('ReferralsAPI', ['$http', 'ENV', 'Session', 'CurrentPatient', 'CurrentReferral', function($http, ENV, Session, CurrentPatient, CurrentReferral) {

	var CP = CurrentPatient;
	var CR = CurrentReferral;
	var service = {

		isProcessing: false,

		startReferral: function() {

			return $http({
				method: 'POST',
				url: ENV.API + '/api/referrals',
				headers: {
					'Authorization': 'Bearer ' + Session.token,
					'Content-Type': 'application/json'
				},
				data: {
					"referrer": {
						"userId": Session.userId
					},
					"patient": {
						"id": CP.patient.id
					},
					"practice": {
						"id": Session.practice.id
					}
				}
			})
		},

		impact: function(formData) {
			formData.id = CR.referral.id;
			return $http({
				method: 'PUT',
				url: ENV.API + '/api/referrals/' + CR.referral.id  + '/impactOnLife',
				headers: {
					'Authorization': 'Bearer ' + Session.token,
					'Content-Type': 'application/json'
				},
				data: formData
			})
		},

		clinical: function(formData) {
			formData.id = CR.referral.id;
			return $http({
				method: 'PUT',
				url: ENV.API + '/api/referrals/' + CR.referral.id  + '/clinicalExamination',
				headers: {
					'Authorization': 'Bearer ' + Session.token,
					'Content-Type': 'application/json'
				},
				data: formData
			})
		},

		complete: function(formData) {
			return $http({
				method: 'PUT',
				url: ENV.API + '/api/referrals/' + CR.referral.id,
				headers: {
					'Authorization': 'Bearer ' + Session.token,
					'Content-Type': 'application/json'
				},
				data: formData,
				responseType: 'arraybuffer'
			})
		},

		completeManual: function(formData) {
			return $http({
				method: 'PUT',
				url: ENV.API + '/api/referrals/' + CR.referral.id + '/manual',
				headers: {
					'Authorization': 'Bearer ' + Session.token,
					'Content-Type': 'application/json',
				},
				data: formData,
				responseType: 'arraybuffer'
			})
		},
		// Every referral held for the patient, newest first. Cataract referrals come from the V1
		// store and every other type - including referrals uploaded through the documents module -
		// from V2, so each item carries a referralSource saying which store its referralId is from.
		getPatientReferrals: function(patientId) {
			return $http({
				method: 'GET',
				url: ENV.API + '/api/referral/v2/patient/' + patientId,
				headers: {
					'Authorization': 'Bearer ' + Session.token,
					'X-PRACTICE-ID': `${Session.practice.id}`
				}
			})
		},
		saveReferralV2: function(referral) {
			return $http({
				method: 'POST',
				url: ENV.API + '/api/referral/v2?sendHL7=true',
				headers: {
					'Authorization': 'Bearer ' + Session.token,
					'Content-Type': 'application/json'
				},
				data: referral,
				responseType: 'arraybuffer'
			})
		},
	};

	return service;
}])